import type { AccessConstraint } from '@sb/shared/access';
import { featureFlag } from '@sb/shared/feature';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the settings-sidebar accordion group headers. */
export const settingsGroupsAccess = {
  employees: { subscriptionPlan: PlanType.BASIC, permission: ['Manage account'] },
  hrPlus: {
    subscriptionPlan: PlanType.BASIC,
    permission: ['Manage account'],
    featureFlag: featureFlag.TMP_HR_PLUS_SETTINGS,
  },
  communications: { subscriptionPlan: PlanType.BASIC, permission: ['Manage account'] },
  timeTracking: { permission: ['Manage account'] },
  insights: { permission: ['Manage account'] },
  schedule: { subscriptionPlan: PlanType.BASIC, permission: ['Manage account'] },
} satisfies Record<string, AccessConstraint>;
